import { useDispatch } from 'react-redux';
import { useUserConfigurationQuery } from '../../services/api';
import { useEffect } from 'react';
import { setUserConfigData } from '../../redux/slices/appSlice';

const useSetUserConfigData = () => {
  const dispatch = useDispatch();
  const { data: userConfigData } = useUserConfigurationQuery();

  useEffect(() => {
    if (userConfigData) {
      dispatch(setUserConfigData(userConfigData));
    }
  }, [userConfigData]);
};

export default useSetUserConfigData;
